import React from "react";
import { useHistory } from "react-router-dom";

const AnswersReview = () => {
  const history = useHistory();

  const examQuestions = JSON.parse(localStorage.getItem("examQuestions"));
  const answeredQsts = JSON.parse(localStorage.getItem("answeredQsts"));
  const correctAnswers = examQuestions.map((element, i) =>
    element.cbtExamsQuestionsOption
      .filter((el) => el.id === element.c_answer)
      .map((item) => item.optionLabel)
  );

  return (
    <>
      {examQuestions[0].c_answer == "" ? (
        <div style={{ margin: "20px" }}>
          <div className="review-card-heading">
            <h3>Solution</h3>
          </div>
          <div className="review-card">
            {examQuestions.map((element, i) =>
              element.cbtExamsQuestionsOption
                .filter((el) => el.id === element.c_answer)
                .map((item) => (
                  <div className="answers-list-item">
                    <div className="question-number">
                      <p className="question-number-i">{i + 1}</p>
                    </div>
                    <p>{item.optionLabel}</p>
                  </div>
                ))
            )}
          </div>
        </div>
      ) : (
        <div style={{ margin: "20px", height: "100%" }}>
          <div className="review-card">
            <h3>Solutions are currently not available for this exam</h3>

            <button
              className="submit-primary"
              onClick={() => history.push("cbt")}
            >
              Home
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AnswersReview;
